import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LeadClockProvider } from './components/leadClock/LeadClockProvider';
import { Landing } from './pages/Landing';
import { BlogIndex } from './pages/BlogIndex';
export function App() {
  return <BrowserRouter data-id="element-0">
      <LeadClockProvider data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Landing data-id="element-4" />} data-id="element-3" />
          <Route path="/blog" element={<BlogIndex data-id="element-6" />} data-id="element-5" />
        </Routes>
      </LeadClockProvider>
    </BrowserRouter>;
}